import { render, staticRenderFns } from "./ClinicMenu.vue?vue&type=template&id=b480f680&scoped=true&"
import script from "./ClinicMenu.vue?vue&type=script&lang=js&"
export * from "./ClinicMenu.vue?vue&type=script&lang=js&"
import style0 from "./ClinicMenu.vue?vue&type=style&index=0&id=b480f680&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b480f680",
  null
  
)

export default component.exports